module.exports = __webpack_public_path__ + "img/product_87.29c15f6.svg";